<template>
  <TabsBtn
    :tabs="tabs"
    :activeTab="activeTab"
    @change="changeTab"
    :isShowBorder="true"
  />
  <div
    v-if="matches.length"
    class="as-h2h as-scrolling as-scrolling__result-popup"
  >
    <div class="as-match-list as-mt-12" :key="activeTab">
      <MatchItem
        v-for="(item, key) in matches"
        :key="key"
        :match="item"
        :teams="matchLiveData.teams"
        :competitions="matchLiveData.competitions"
        :commentators="matchLiveData.commentators"
        :isShowFlagHalf="false"
        :mode="mode"
      />
    </div>
  </div>
  <NoData v-else />
</template>

<script setup lang="ts">
import { defineProps, ref, computed } from "vue";
import type { IMatch, IMatchLiveData } from "~src/interfaces/basketball";
import MatchItem from "~src/components/matches/basketball/MatchItem.vue";
import MatchEnum from "~src/enums/basketball/MatchEnum";
import NoData from "~src/components/NoData.vue";
import TabsBtn from "~src/components/TabsBtn.vue";

interface IProps {
  matchLiveData: IMatchLiveData;
  matchId: string;
  mode?: string;
}

const props = withDefaults(defineProps<IProps>(), {});

const activeTab = ref("all");

const tabs = [
  {
    title: "Tất cả trận",
    key: "all",
  },
  {
    title: "Có bàn thắng",
    key: "goal",
  },
  {
    title: "Chưa bàn thắng",
    key: "no_goal",
  },
  {
    title: "H1",
    key: "h1",
  },
  {
    title: "H2",
    key: "h2",
  },
  {
    title: "H3",
    key: "h3",
  },
  {
    title: "H4",
    key: "h4",
  },
  {
    title: "OT",
    key: "ot",
  },
];

const matches = computed(() => {
  return props.matchLiveData.matches.filter((match: IMatch) => {
    if (
      match.id === props.matchId ||
      match.status_id === MatchEnum.STATUS_END
    ) {
      return false;
    }

    if (activeTab.value === "all") {
      return true;
    }

    if (!MatchEnum.LIST_STATUS_PLAYING.includes(match.status_id)) {
      return false;
    }

    if (activeTab.value === "goal") {
      if (match.home_scores[0] != 0 || match.away_scores[0] != 0) {
        return true;
      }

      return false;
    } else if (activeTab.value === "no_goal") {
      if (match.home_scores[0] == 0 && match.away_scores[0] == 0) {
        return true;
      }

      return false;
    } else if (activeTab.value === "h1") {
      if (match.status_id === MatchEnum.STATUS_SECTION_ONE) {
        return true;
      }

      return false;
    } else if (activeTab.value === "h2") {
      if (match.status_id === MatchEnum.STATUS_SECTION_TWO) {
        return true;
      }

      return false;
    } else if (activeTab.value === "h3") {
      if (match.status_id === MatchEnum.STATUS_SECTION_THREE) {
        return true;
      }

      return false;
    } else if (activeTab.value === "h4") {
      if (match.status_id === MatchEnum.STATUS_SECTION_FOUR) {
        return true;
      }

      return false;
    } else if (activeTab.value === "ot") {
      if (match.status_id === MatchEnum.STATUS_OVERTIME) {
        return true;
      }

      return false;
    }

    return true;
  });
});

const wait = async (ms: number) => {
  return new Promise((resolve) => setTimeout(resolve, ms));
};

const changeTab = async (tab: string) => {
  activeTab.value = tab;
};
</script>

<script lang="ts">
export default {};
</script>
